import React, { useRef, useMemo } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import * as THREE from 'three'
import model from "../../../Assets/Walls/FrontWall/FrontWall.glb"
import AOTex from "../../../Assets/Walls/FrontWall/Front_Wall_AO.jpg"

export default function Model({ size }) {
  const group = useRef()
  const ref = useRef()
  const { nodes, materials } = useGLTF(model)

  const aoMap = useTexture(AOTex)
  aoMap.flipY = false
  aoMap.encoding = THREE.RGBFormat

  const wallMaterial = useMemo(() => new THREE.MeshPhongMaterial({
      aoMap : aoMap,
      aoMapIntensity: 1.2,
      color : "#A3A0A3",
      emissive : 0x111111,
      emissiveIntensity : 0.2,
      lightMap : aoMap,
      lightMapIntensity : 0.2,
      side : THREE.DoubleSide
    })
  , [])
  const dummy = React.useMemo(() => new THREE.Object3D(), [])

  React.useLayoutEffect(() => {

    const uvs = ref.current.geometry.attributes.uv.array;
    ref.current.geometry.setAttribute( 'uv2', new THREE.BufferAttribute( uvs, 2 ) );

    const i = [-1, 1]
    for (let index = 0; index < 2; index++) {
      dummy.position.set(((size+48)/2)*100 * i[index], 0, 0)
      dummy.updateMatrix()
      ref.current.setMatrixAt(index, dummy.matrix)
    }
    ref.current.instanceMatrix.needsUpdate = true
  }, [size])

  

  return (
    <group ref={group} scale={[1, 3, 3]} dispose={null}>
      <instancedMesh
        ref={ref}
        args={[nodes.front_Wall.geometry, null, 2]}
        material={wallMaterial}
        position={[-0.41, -0.04, -15.75]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.01, 0.01, 0.01]}
      >
        {/* <meshPhongMaterial 
          side={THREE.DoubleSide}
          aoMap={AOMap}
          // aoMapIntensity={1.5}
          color={"#A3A0A3"}
          lightMap={AOMap}
          specular={"#3A3A3A"}
          shininess={24.16}
          emissive={"#000000"}
        /> */}
      </instancedMesh>
    </group>
  )
}

useGLTF.preload(model)
